import Button from '@/components/Button'
import Image from 'next/image'
import styles from './JobsFeed.module.scss'

export default function JobsFeed(props) {
  const { jobs } = props.fields

  const handleJobClick = (url) => {
    if (!url) return

    if (url.startsWith('http') || url.startsWith('/')) {
      // Use window.location.assign for navigation (React-safe)
      window.location.assign(url)
    } else {
      const id = url.replace(/^#/, '')
      const offset = 80
      const element = document.getElementById(id)
      if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset - offset
        window.scrollTo({ top: y, behavior: 'smooth' })
      }
    }
  }

  return (
    <div className={styles.jobsFeed}>
      <div data-aos="fade-up">
        <div className="container">
          <h2>Job Opportunities at Integrity</h2>
          <div className={styles.jobs}>
            {jobs.map((job, index) => {
              const isLink = !!job.jobUrl

              const content = (
                <>
                  <div className={styles.image}>
                    <Image
                      src={job.jobIcon ? job.jobIcon.node.sourceUrl : ''}
                      width={300}
                      height={150}
                      alt={job.jobIcon ? job.jobIcon.node.altText : ''}
                    />
                  </div>
                  <h3>{job.jobTitle}</h3>
                </>
              )

              return isLink ? (
                <Button key={index} className={styles.job} onClick={() => handleJobClick(job.jobUrl)}>
                  {content}
                </Button>
              ) : (
                <div key={index} className={styles.job}>
                  {content}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
